import { render, staticRenderFns } from "./NewDashboard.vue?vue&type=template&id=d6b79d74&scoped=true"
import script from "./NewDashboard.vue?vue&type=script&lang=js"
export * from "./NewDashboard.vue?vue&type=script&lang=js"
import style0 from "./NewDashboard.vue?vue&type=style&index=0&id=d6b79d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b79d74",
  null
  
)

export default component.exports